/**
 * 商品情報ページにおいて、関連商品のアイテム内から現在表示している商品のアイテムを削除する
 * 削除した際に中身が空になったら、そのエリアごと削除する（残しておきたい要素がいたらjs-remove-current-product__ignoreクラスを付与する）
 */
export default () => {
    const roots = document.querySelectorAll('.js-remove-current-product');

    if (!roots) {
        return;
    }
    roots.forEach((root) => {
        const {currentProductId} = root.dataset;
        const targets = [];

        root.querySelectorAll('.js-remove-current-product__target').forEach((target) => {
            if (target.dataset.productId !== currentProductId) {
                targets.push(target);

                return;
            }
            target.outerHTML = '';
        });

        if (targets.length === 0) {
            const ignoreElement = root.querySelectorAll('.js-remove-current-product__ignore');

            if (ignoreElement) {
                root.innerHTML = '';
                for (const elem of ignoreElement) {
                    root.insertAdjacentElement('beforeend', elem);
                }

                return;
            }

            root.outerHTML = '';
        }
    });
};
